const authRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Account/Login.vue')     
    },
    {
        path: '/retrieve-password',
        name: 'Retrieve Password',
        component: () => import('@/views/Account/Retrievepassword.vue')       
    },
    {
        path: '/change-password',
        name: 'Change Password',
        component: () => import('@/views/Account/Changepassword.vue')       
    },
    {
        path: '/school-registration',
        name: 'School Registration',
        component: () => import('@/views/Account/SchoolRegistration.vue')       
    }
   
]

export default authRoutes
